/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const BRENN: CommunityData = {
  code: "brenn",
  inviteCode: "brenn",
  name: "BRENN.",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/bre-656`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#ffffff",
      logo: {
        src: "https://media.werz.at/community/icon/cmgqjn4j500019k2qn8mgyg5j.jpg?uploadTime=1760522394751&type=image&v=1762238616236",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/brenn/web-alternative-logo.png",
        styles: "w-[198px] h-[38px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#ff0000",
      asideBg: "#ff0000",
      asideStyles: "bg-[#ff0000] border-r border-[#ffffff80]",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: "https://media.werz.at/community-assets/brenn/web-background.jpg",
      bgMobile: "https://media.werz.at/community-assets/brenn/web-background-mobile.jpg",
      nonMemberBg: "https://media.werz.at/community-assets/brenn/web-background-non-member.jpg",
      mainFont: "font-['NeueHaasGroteskDisplayPro55Roman']",
      primaryButton:
        "bg-[#000000] border border-[#000000] px-[18px] py-[18px] !text-[#ffffff] font-['AcuminProExtraCondensedBlack'] !text-[22px] uppercase text-left",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#ffffff80]",
      separator: "#ffffff80",
      item: "text-[#ffffff] font-['AcuminProExtraCondensedBlack'] text-[22px] uppercase text-center leading-[100%] gap-x-[10px] text-opacity-50 border-b border-[#ffffff80] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "bg-[#ffffff] border-[#000000] !pb-8 overflow-hidden",
      titles:
        "text-[#000000] font-['AcuminProUltraBlackItalic'] text-[26px] uppercase text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[130%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0",
        sectionTitle:
          "text-[#000000] font-['AcuminProUltraBlackItalic'] text-[26px] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#000000] font-['AcuminProUltraBlackItalic'] text-[16px] uppercase text-left leading-[100%]",
          subtitle:
            "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[12px] text-left leading-[130%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0",
        sectionTitle:
          "text-[#000000] font-['AcuminProUltraBlackItalic'] text-[26px] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent",
          title:
            "text-[#000000] font-['AcuminProExtraCondensedBlack'] text-[20px] uppercase text-left leading-[100%]",
          subtitle:
            "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] text-left leading-[130%]",
          location:
            "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] text-left leading-[130%]",
          date: "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] text-left leading-[130%]",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#000000] font-['AcuminProUltraBlackItalic'] text-[24px] uppercase text-left leading-[100%]",
        text: "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[17px] text-left leading-[130%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#000000] font-['AcuminProUltraBlackItalic'] text-[26px] uppercase text-left leading-[100%] !mb-4 sm:!mb-4",
      },
    },
    comingSoon: {
      bgColor: "#ffffff",
      hero: {
        desktop: "https://media.werz.at/community-assets/brenn/wm-landing-bg.mp4?type=video",
        mobile: "https://media.werz.at/community-assets/brenn/wm-landing-bg.mp4?type=video",
        style: "bg-[#ff0000]",
      },
      logo: {
        desktop: "https://media.werz.at/community-assets/brenn/web-alternative-logo.png",
        mobile: "https://media.werz.at/community-assets/brenn/web-alternative-logo.png",
        style: "w-[140px] h-[27px] sm:w-[198px] sm:h-[38px]",
      },
      werzLogoColor: "#191818",
      title:
        "font-['AcuminProUltraBlackItalic'] text-[28px] leading-[120%] text-[#000000] uppercase",
      text: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-[#000000]",
      button:
        "font-['AcuminProExtraCondensedBlack'] text-[16px] leading-[120%] p-4 bg-[#000000] text-[#ffffff] cursor-pointer w-fit uppercase",
      input: {
        base: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-white text-[#000000]",
        border: "#D4D4D4",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText:
        "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#8D8D8D]",
      skipButton:
        "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#8D8D8D] cursor-pointer",
      modal: {
        container: "bg-[#f0f0f0] px-[40px] py-[48px]",
        title:
          "font-['AcuminProUltraBlackItalic'] text-[24px] leading-[120%] text-[#000000] text-center uppercase",
        text: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#8D8D8D] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#000000] bg-white font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-center",
        otpBorder: "#D4D4D4",
        otpBorderFocus: "#000000",
      },
    },
    linktree: {
      bgDesktop: "https://media.werz.at/community-assets/brenn/web-background-non-member.jpg",
      bgMobile: "https://media.werz.at/community-assets/brenn/web-background-non-member.jpg",
      bgColor: "#ff0000",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#ff0000]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#000000]",
        name: "text-[#191818] font-['AcuminProUltraBlackItalic'] text-[26px] uppercase leading-[26px] text-center text-center mt-4 mb-1",
        location:
          "font-['AcuminProUltraBlackItalic'] uppercase leading-[20px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[17px] leading-[130%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#ffffff",
        button:
          "bg-[#000000] border border-[#000000] px-4 py-3 text-[#ffffff] font-['AcuminProExtraCondensedBlack'] text-[18px] uppercase text-left w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ff0000] border border-[#000000] text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[17px] leading-[130%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#ff0000] border border-[#000000]",
          title:
            "font-['AcuminProUltraBlackItalic'] uppercase leading-[20px] text-[16px] text-left text-center mb-1",
          text: "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[17px] leading-[130%] text-center text-center",
          button:
            "bg-[#000000] border border-[#000000] px-4 py-3 text-[#ffffff] font-['AcuminProExtraCondensedBlack'] text-[18px] uppercase text-left w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#191818] font-['AcuminProUltraBlackItalic'] uppercase leading-[20px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ff0000] border border-[#000000]",
          duration:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] leading-[16.9px] text-left",
          name: "text-[#000000] font-['AcuminProUltraBlackItalic'] uppercase leading-[20px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#ffffff",
          media: "overflow-hidden m-2 border border-[#000000]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#ff0000] border border-[#000000]",
          name: "text-[#000000] font-['AcuminProUltraBlackItalic'] uppercase leading-[20px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#000000] border border-[#000000] text-[#ffffff] font-['AcuminProExtraCondensedBlack'] text-[20px] uppercase leading-[20px] text-center",
          duration:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] leading-[16.9px] text-left",
          location:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] leading-[16.9px] text-left",
          button:
            "bg-[#000000] border border-[#000000] px-4 py-3 text-[#ffffff] font-['AcuminProExtraCondensedBlack'] text-[18px] uppercase text-left w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#000000]",
            name: "text-[#000000] font-['AcuminProExtraCondensedBlack'] uppercase leading-[20px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#000000] font-['AcuminProExtraCondensedBlack'] uppercase leading-[20px] text-[14px] text-left",
            link: "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] leading-[19.5px] text-left",
            status:
              "text-[#000000] font-['AcuminProExtraCondensedBlack'] uppercase leading-[100%] text-[14px] text-left",
            button:
              "bg-[#000000] border border-[#000000] px-4 py-3 text-[#ffffff] font-['AcuminProExtraCondensedBlack'] text-[18px] uppercase text-left w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[17px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ff0000] border border-[#000000] text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[17px] leading-[130%] text-center",
        header:
          "text-[#191818] font-['AcuminProUltraBlackItalic'] uppercase leading-[20px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ff0000] border border-[#000000]",
          name: "text-[#000000] font-['AcuminProUltraBlackItalic'] uppercase leading-[20px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#ffffff",
          created:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] leading-[16.9px] text-left",
          media: "overflow-hidden m-2 border border-[#000000]",
        },
        seeAllNews:
          "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[17px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ff0000] border border-[#000000] text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[17px] leading-[130%] text-center",
        header:
          "text-[#191818] font-['AcuminProUltraBlackItalic'] uppercase leading-[20px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#ff0000] border border-[#000000]",
          coverUrl: "overflow-hidden m-2 border border-[#000000]",
          duration:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] leading-[16.9px] text-left",
          liveType:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] leading-[16.9px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#000000] rounded-full",
          playIconColor: "#FFF",
          playIconBackgroundColor: "#000000",
          playIconBorderColor: "#FFF",
          start:
            "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] leading-[16.9px] text-left",
          title:
            "text-[#000000] font-['AcuminProUltraBlackItalic'] uppercase leading-[20px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[17px] leading-[130%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#ff0000] border border-[#000000] text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[17px] leading-[130%] text-center",
        header:
          "text-[#191818] font-['AcuminProUltraBlackItalic'] uppercase leading-[20px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#ff0000] border border-[#000000]",
          name: "text-[#000000] font-['AcuminProUltraBlackItalic'] uppercase leading-[20px] text-[16px] text-left",
          triangleIconColor: "#ffffff",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#000000]",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[13px] leading-[16.9px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ffffff] border-[#000000] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#000000] font-['AcuminProUltraBlackItalic'] text-[26px] uppercase text-left leading-[100%]",
        subtitle:
          "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[130%] mb-4 mt-2",
        button:
          "bg-[#000000] border border-[#000000] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['AcuminProExtraCondensedBlack'] text-[22px] uppercase text-left leading-[100%]",
        questions: "text-[15px] text-left leading-[130%]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['AcuminProUltraBlackItalic'] text-[24px] uppercase text-left leading-[100%]",
        text: "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[130%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['AcuminProUltraBlackItalic'] text-[24px] uppercase text-left leading-[100%]",
        text: "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[130%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px] border border-[#000000]",
        mapPinColor: "#000000",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['AcuminProUltraBlackItalic'] text-[24px] uppercase text-left leading-[100%]",
        text: "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[130%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['AcuminProUltraBlackItalic'] text-[26px] uppercase text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 pb-4 sm:pb-6 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ffffff] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "!bg-[#000000] border border-[#000000] px-4 py-3 text-[#ffffff] font-['AcuminProExtraCondensedBlack'] text-[18px] uppercase text-left !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto bg-[#ffffff00] border-b border-[#000000] mb-4 pb-2 sm:pb-4overflow-hidden",
          media: "!hidden",
          name: "text-[#000000] font-['AcuminProExtraCondensedBlack'] text-[20px] uppercase text-left leading-[100%]",
          description:
            "text-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[130%] !mt-1",
          price:
            "text-[#000000] font-['AcuminProExtraCondensedBlack'] text-[20px] uppercase text-left leading-[110%] !mt-1",
          quantity: "text-[#ffffff] font-['AcuminProExtraCondensedBlack'] text-[18px] text-left",
          status:
            "text-[#000000] font-['AcuminProExtraCondensedBlack'] text-[20px] uppercase text-left leading-[100%]",
          counterContainer:
            "bg-[#000000] border border-[#000000] !px-4 !py-3 gap-x-4 !w-fit !h-[43px]",
          button:
            "!bg-[#000000] border border-[#000000] px-4 py-3 text-[#ffffff] font-['AcuminProExtraCondensedBlack'] text-[18px] uppercase text-left !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default BRENN
